export const MONTHS_PT = [
    "01", "02", "03", "04", "05", "06",
    "07", "08", "09", "10", "11", "12",
];

export const getDaysInMonth = (year: number, month: number): number =>
    new Date(year, month, 0).getDate();

export const getStartWeekdayOfMonth = (year: number, month: number): number => {
    const day = new Date(year, month - 1, 1).getDay();
    return day === 0 ? 6 : day - 1; // 0 = Seg, 6 = Dom
};


 /* Devolve uma matriz 2D onde cada linha representa uma semana com 7 posições.
    Posições com 0 representam dias fora do mês atual.*/
 
export const calculateWeeksOfMonth = (year: number, month: number): number[][] => {
    const totalDays = getDaysInMonth(year, month);
    const startWeekday = getStartWeekdayOfMonth(year, month);

    const result: number[][] = [];
    let current: number[] = [];

    // Preencher dias vazios antes do dia 1
    for (let i = 0; i < startWeekday; i++) current.push(0);

    for (let day = 1; day <= totalDays; day++) {
        current.push(day);
        if (current.length === 7) {
            result.push(current);
            current = [];
        }
    }

    // Preencher dias vazios no fim do mês
    if (current.length > 0) {
        while (current.length < 7) current.push(0);
        result.push(current);
    }

    return result;
};

 // Calcula qual a semana atual em que estamos (ou a primeira semana se o mapa for de outro mês).
export const getInitialWeekIndex = (year: number, month: number, weeks: number[][]): number => {
    const now = new Date();
    if (now.getMonth() + 1 === month && now.getFullYear() === year) {
        const currentDay = now.getDate();
        const idx = weeks.findIndex((w) => w.includes(currentDay));
        if (idx !== -1) return idx;
    }
    return 0;
};